import { useLocalSettings } from "@hooks/useStorage";
import { useState, useEffect } from "react";
import Snowfall from "react-snowfall";

// !XMAS
export const SnowTheme = () => {
  const { settings } = useLocalSettings();

  useEffect(() => {
    const el = document.querySelector<HTMLCanvasElement>('[data-testid="SnowfallCanvas"]');
    const onScroll = () => {
      if (!el) return;
      el.style.top = `${window.scrollY}px`;
    };
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  if (!settings.xmas) return <></>;

  return (
    <>
      <Snowfall snowflakeCount={settings.xmas_flake} speed={[0.4, 1.4]} />
      <SnowBg />
    </>
  );
};

export default SnowTheme;

const SnowBg = () => {
  const [statefulStyles, setStyles] = useState<React.CSSProperties>({ height: "100vh" });

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      // wrap in requestAnimationFrame to avoid "ResizeObserver loop limit exceeded error",
      // which we can safely ignore according to: https://stackoverflow.com/a/58701523
      window.requestAnimationFrame(() => {
        // TODO: we could possibly move the frame when scroll happens?
        // to keep the snow in view in case user scrolls too far down
        const clientHeight = entries[0]?.target?.clientHeight || 0;
        const innerHeight = window.innerHeight || 0;
        const height = (innerHeight > clientHeight ? innerHeight : clientHeight) - 50;
        const next: React.CSSProperties = {
          height,
          // hack to lower the opacity on item pages, since they've a background image.
          opacity: window.location.pathname.includes("/d/item") ? 0.02 : 0.15,
        };

        setStyles((prev) => ({ ...prev, ...next }));
      });
    });

    resizeObserver.observe(document.body);
    return () => {
      resizeObserver.unobserve(document.body);
    };
  }, []);

  return (
    <div
      style={{
        ...statefulStyles,
        backgroundImage: `url("/xmas-bg-1.jpg")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        zIndex: -1000,
        backgroundAttachment: "fixed",
        backgroundRepeat: "repeat",
        top: 50,
        left: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
      }}
    />
  );
};
